import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_3 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_nota_fiscal_detalhe_pagamento_centro_custo = _resolveComponent("nota-fiscal-detalhe-pagamento-centro-custo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form_item, {
          label: "Valor",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              monetario: true,
              quantidadeCasasDecimais: 2,
              valorMaximo: _ctx.props.valorRestante,
              valor: _ctx.computedValorParcelado,
              "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValorParcelado) = $event))
            }, null, 8, ["valorMaximo", "valor"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_form_item, {
          label: "Data Vencimento",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_data, {
              dataSelecionada: _ctx.computedDataVencimento,
              "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedDataVencimento) = $event))
            }, null, 8, ["dataSelecionada"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_form_item, {
          label: "Qtd de Parcelas",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_generico, {
              itens: _ctx.props.parcelas,
              valor: _ctx.computedQtdParcelas,
              "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedQtdParcelas) = $event)),
              limparSelecao: false
            }, null, 8, ["itens", "valor"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_form_item, {
          label: "Categoria do Plano de Contas",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_categoria_plano_conta, {
              empresas: [_ctx.props.empresa],
              tipoPlanoConta: 1,
              codigoSelecionado: _ctx.computedCodigoPlanoConta,
              "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedCodigoPlanoConta) = $event)),
              descricaoSelecionado: _ctx.computedNomePlanoConta,
              "onUpdate:descricaoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedNomePlanoConta) = $event))
            }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_nota_fiscal_detalhe_pagamento_centro_custo, {
          visivel: true,
          codigoRegistro: 0,
          valor: _ctx.props.valorRestante,
          centrosCusto: _ctx.computedCentroCustos,
          "onUpdate:centrosCusto": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedCentroCustos) = $event)),
          editavel: true
        }, null, 8, ["valor", "centrosCusto"])
      ])
    ])
  ], 64))
}